import {
    Badge,
    Box,
    Button,
    Card,
    Container,
    Group,
    LoadingOverlay,
    Modal,
    Paper,
    Select,
    SimpleGrid,
    Stack,
    Tabs,
    Text,
    TextInput,
} from '@mantine/core';
import {
    CAMPAIGN_TYPES,
    DATA_MANAGER_TYPES,
    OFFER_CATEGORIES,
} from '../../../../common/enums/enums';
import { MultiSelectCreatable, SearchableSelect } from '../../../../common';
import {
    getChatHandlers,
    getDatasets,
    getLinkGroups,
    getMediaGroups,
    getMessageGroups,
    getUserDatasets,
    getUserRoutes,
    getUserVerticals,
    getVerticals,
} from '../../../../../http/apiClient';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinnerThird } from '@fortawesome/pro-solid-svg-icons';
import { hasRole } from '../../../../../utils/roles';
import { toGroupedOptions } from '../../../../../utils/enumUtils';
import { useAuthStore } from '../../../../../store';
import { useEffect } from 'react';
import { useForm } from '@mantine/form';
import { useParams } from 'react-router-dom';

const SmsCampaignSubview = ({ form, campaign }) => {
    useEffect(() => {}, [campaign]);
    const userProfile = useAuthStore((state) => state.userProfile);
    //const { isPending, mutate: addOrUpdate } = useAddMessageGroup();

    const userQueryHttpFn = (queryHttpFn, queryParams) => {
        const userId = form.values.userId;
        const searchUserRoutes = hasRole(userProfile, 'SUPER_ADMIN') && userId;

        if (searchUserRoutes) {
            return queryHttpFn({
                userId,
                type: 'sms',
                pagination: queryParams,
            });
        }
        return queryHttpFn({
            type: 'sms',
            pagination: queryParams,
        });
    };

    return (
        <>
            <SearchableSelect
                label={'Route'}
                withAsterisk
                placeholder='Select sending route'
                queryHttpFn={(queryParams) =>
                    userQueryHttpFn(getUserRoutes, queryParams)
                }
                queryKey={
                    form.values.userId
                        ? ['user_routes', 'sms', form.values.userId]
                        : ['user_routes', 'sms']
                }
                optionsMapFn={(route) => ({
                    label: route.name,
                    value: route.id.toString(),
                })}
                defaultValue={
                    campaign?.route
                        ? {
                              label: campaign.route.name,
                              value: campaign.route.id.toString(),
                          }
                        : null
                }
                key={form.key('routeId')}
                {...form.getInputProps('routeId')}
            />

            <Select
                label={'Data Manager'}
                placeholder='Select data manager'
                data={DATA_MANAGER_TYPES}
                withAsterisk
                key={form.key('dataManager')}
                {...form.getInputProps('dataManager')}
            />

            <SearchableSelect
                label={'Dataset'}
                withAsterisk
                placeholder='Select dataset'
                queryHttpFn={(queryParams) =>
                    userQueryHttpFn(getUserDatasets, queryParams)
                }
                queryKey={
                    form.values.userId
                        ? ['data_sets', 'sms', form.values.userId]
                        : ['data_sets', 'sms']
                }
                optionsMapFn={(dataset) => ({
                    label: dataset.name,
                    value: dataset.id.toString(),
                })}
                key={form.key('dataSetId')}
                {...form.getInputProps('dataSetId')}
            />

            <SearchableSelect
                label={'Clicker Dataset'}
                placeholder='Select clicker dataset (optional)'
                queryHttpFn={(queryParams) =>
                    userQueryHttpFn(getUserDatasets, {
                        ...queryParams,
                        type: 'Clickers',
                    })
                }
                queryKey={
                    form.values.userId
                        ? ['data_sets', 'sms', form.values.userId, 'clickers']
                        : ['data_sets', 'sms', 'clickers']
                }
                optionsMapFn={(dataset) => ({
                    label: dataset.name,
                    value: dataset.id.toString(),
                })}
                key={form.key('clickerDataSetId')}
                {...form.getInputProps('clickerDataSetId')}
            />

            <SearchableSelect
                label={'Message Group'}
                placeholder='Select message group'
                queryHttpFn={(queryParams) =>
                    userQueryHttpFn(getMessageGroups, queryParams)
                }
                queryKey={
                    form.values.userId
                        ? ['message_groups', 'sms', form.values.userId]
                        : ['message_groups', 'sms']
                }
                optionsMapFn={(x) => ({
                    label: x.name,
                    value: x.id?.toString(),
                })}
                withAsterisk
                key={form.key('smsOptions.messageGroupId')}
                {...form.getInputProps('smsOptions.messageGroupId')}
            />

            {/*<SearchableSelect
                label={'Media Group'}
                placeholder='Select media group (optional)'
                queryHttpFn={(queryParams) =>
                    userQueryHttpFn(getMediaGroups, queryParams)
                }
                queryKey={
                    form.values.userId
                        ? ['media_groups', 'sms', form.values.userId]
                        : ['media_groups', 'sms']
                }
                optionsMapFn={(x) => ({
                    label: x.name,
                    value: x.id?.toString(),
                })}
                key={form.key('smsOptions.mediaGroupId')}
                {...form.getInputProps('smsOptions.mediaGroupId')}
            />*/}

            <SearchableSelect
                label={'Link Group'}
                placeholder='Select link group'
                queryHttpFn={(queryParams) =>
                    userQueryHttpFn(getLinkGroups, queryParams)
                }
                queryKey={
                    form.values.userId
                        ? ['link_groups', 'sms', form.values.userId]
                        : ['link_groups', 'sms']
                }
                optionsMapFn={(x) => ({
                    label: x.name || 'test',
                    value: x.id?.toString(),
                })}
                withAsterisk
                key={form.key('smsOptions.linkGroupId')}
                {...form.getInputProps('smsOptions.linkGroupId')}
            />

            <SearchableSelect
                label={'Chat Handler'}
                placeholder='Select chat handler (optional)'
                queryHttpFn={(queryParams) =>
                    userQueryHttpFn(getChatHandlers, queryParams)
                }
                queryKey={
                    form.values.userId
                        ? ['chat_handlers', form.values.userId]
                        : ['chat_handlers']
                }
                optionsMapFn={(x) => ({
                    label: x.name || 'test',
                    value: x.id?.toString(),
                })}
                key={form.key('chatHandlerId')}
                {...form.getInputProps('chatHandlerId')}
            />
        </>
    );
};
export default SmsCampaignSubview;
